import { configureStore } from "@reduxjs/toolkit";
import userReducer from './slices/userSlice'
import { loginAuth } from "./services/auth/auth";
import themeReducer from "../reduxServer/slices/themSlices";
import languageReducer from '../reduxServer/slices/languageSlice'
import { faqApiFetching } from "./services/faqs";
import { specializationsApiFetching } from "./services/specializations";
import { ConsultationsApiFetching } from "./services/consultations";
import { profileApi } from "./services/userAccount";
import { lawyerApi } from "./services/lawyer";
import { bannerApi } from "./services/banner";  
import { ChatHistroyApiFetching } from "./services/chatHistroy";
import { casesApi } from "./services/Cases";
import { notificationApi } from "./services/notifications";
import {adminStaffApi} from "./services/adminStaff"
import {clientApi} from "./services/client"
export const store = configureStore({

  reducer: {
    user: userReducer,
    theme: themeReducer,
    language: languageReducer,
    [loginAuth.reducerPath]: loginAuth.reducer,
    [faqApiFetching.reducerPath]: faqApiFetching.reducer,
    [specializationsApiFetching.reducerPath]: specializationsApiFetching.reducer,
     [ConsultationsApiFetching.reducerPath]: ConsultationsApiFetching.reducer,
     [profileApi.reducerPath]: profileApi.reducer,
     [lawyerApi.reducerPath]: lawyerApi.reducer,
     [bannerApi.reducerPath]: bannerApi.reducer,
     [ChatHistroyApiFetching.reducerPath]: ChatHistroyApiFetching.reducer,
     [casesApi.reducerPath]: casesApi.reducer,
      [notificationApi.reducerPath]: notificationApi.reducer,
      [adminStaffApi.reducerPath]: adminStaffApi.reducer,
      [clientApi.reducerPath]: clientApi.reducer,







  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      loginAuth.middleware,
      faqApiFetching.middleware,
      specializationsApiFetching.middleware,
      ConsultationsApiFetching.middleware,
      profileApi.middleware,
      lawyerApi.middleware,
      bannerApi.middleware,
      ChatHistroyApiFetching.middleware,
      casesApi.middleware,
      notificationApi.middleware,
      adminStaffApi.middleware,
      clientApi.middleware,



    ),
});

// Types for TS
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;